export default {
  GRAPHQL_URL: '/api/edge/graphql',
}
